<div
  class="
    row
    vh-100
    app-bg-mono
    d-flex
    flex-column
    justify-content-center
    align-items-center
    app-bg-mono
    vw-100
  "
> 
  <img [src]="imageToShow" style="margin-bottom: 3em" class="img-thumbnail" />
  <div  style="    text-align: center !important;"  class="app-button-container">
    <app-continue-button  [label]="label"></app-continue-button>
  </div>
</div>
